export default "__VITE_ASSET__D_rpgOF3__"